import Link from "next/link";
import { Layout } from "../../components/layout/layout.comp";
import { LongCopy } from "../../components/longCopy/longCopy.comp";

export default function DpaPage() {
    return (
        <Layout
            showHeader={true}
            showFooter={true}
            title="Data Processing Agreement"
            url={`https://www.bracketsninja.com/privacy/dpa`}
        >

            <LongCopy title="Data Processing Agreement" >
                <p>
                    <span style={{ fontWeight: 400 }}>
                        This Data Processing Addendum (&ldquo;
                    </span>
                    <strong>DPA</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;) is incorporated by reference into{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja&rsquo;s Terms and Conditions available at&nbsp;
                    </span>
                    <a href="https://www.bracketsninja.com/terms">
                        <span style={{ fontWeight: 400 }}>
                            https://www.bracketsninja.com/terms
                        </span>
                    </a>
                    <span style={{ fontWeight: 400 }}> or other</span>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        agreement governing the use of{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Common Ninja&rsquo;s</span>
                    <span style={{ fontWeight: 400 }}> services (&ldquo;</span>
                    <strong>Agreement</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;) entered by and between you, the user/developer/customer
                        using the Common Ninja services and platform
                        (collectively,&nbsp;&ldquo;
                    </span>
                    <strong>you</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;,&nbsp;&quot;</span>
                    <strong>your</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;, &ldquo;</span>
                    <strong>Customer</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;), and </span>
                    <span style={{ fontWeight: 400 }}>Common Ninja Ltd. </span>
                    <span style={{ fontWeight: 400 }}>(&ldquo;</span>
                    <strong>Common Ninja</strong>
                    <strong>&rdquo;,</strong>
                    <span style={{ fontWeight: 400 }}>&nbsp;&ldquo;</span>
                    <strong>us</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;,&nbsp;&ldquo;</span>
                    <strong>we</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;,&nbsp;&ldquo;</span>
                    <strong>our</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;)</span>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        to reflect the parties&rsquo; agreement with regard to the
                        Processing of Personal Data by{' '}
                    </span>
                    <span style={{ fontWeight: 400 }}>Common Ninja </span>
                    <span style={{ fontWeight: 400 }}>
                        solely on behalf of the Customer. Both parties shall be referred to
                        as the &ldquo;
                    </span>
                    <strong>Parties</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo; and each, a &ldquo;</span>
                    <strong>Party</strong>
                    <span style={{ fontWeight: 400 }}>&rdquo;.&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        If you cannot, or do not agree to, comply with and be bound by this
                        DPA, or do not have authority to bind the Customer or any other
                        entity, please do not provide Personal Data to us.
                    </span>
                    <span style={{ fontWeight: 400 }}>
                        {' '}
                        In the event of any conflict between certain provisions of this DPA
                        and the provisions of the Agreement, the provisions of this DPA
                        shall prevail over the conflicting provisions of the Agreement
                        solely with respect to the Processing of Personal Data.&nbsp;
                    </span>
                </p>
                <h4>1. DEFINITIONS</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Affiliate</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means any entity that directly or indirectly controls, is
                            controlled by, or is under common control with the subject entity.
                            &ldquo;Control&rdquo;, for purposes of this definition, means
                            direct or indirect ownership or control of more than 50% of the
                            voting interests of the subject entity.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>CCPA</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means the California Consumer Privacy Act of 2018, Cal.
                            Civ. Code &sect;&sect; 1798.100 et. seq.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>The terms, &quot;</span>
                        <strong>Controller</strong>
                        <span style={{ fontWeight: 400 }}>&quot;, &quot;</span>
                        <strong>Member State</strong>
                        <span style={{ fontWeight: 400 }}>&quot;, &quot;</span>
                        <strong>Processor</strong>
                        <span style={{ fontWeight: 400 }}>&quot;, &quot;</span>
                        <strong>Processing</strong>
                        <span style={{ fontWeight: 400 }}>&quot; and &quot;</span>
                        <strong>Supervisory Authority</strong>
                        <span style={{ fontWeight: 400 }}>
                            &quot; shall have the same meaning as in the GDPR. The terms &ldquo;
                        </span>
                        <strong>Business</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;, &ldquo;</span>
                        <strong>Business Purpose</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;, &ldquo;</span>
                        <strong>Consumer</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo; and &ldquo;</span>
                        <strong>Service Provider</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; shall have the same meaning as in the CCPA.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            For the purpose of clarity, within this DPA &ldquo;
                        </span>
                        <strong>Controller</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; shall also mean &ldquo;
                        </span>
                        <strong>Business</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;, and &ldquo;</span>
                        <strong>Processor</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; shall also mean &ldquo;
                        </span>
                        <strong>Service Provider</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;, to the extent that the CCPA applies. In the same manner,
                            Processor&rsquo;s Sub-processor shall also refer to the concept of
                            Service Provider.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Data Protection Laws</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means all applicable and binding privacy and data
                            protection laws and regulations, including such laws and
                            regulations of the European Union, the European Economic Area and
                            their Member States, Switzerland, the United Kingdom, Israel and
                            the United States of America, as applicable to the Processing of
                            Personal Data under the Agreement including (without limitation)
                            the GDPR, the UK GDPR, the FADP and the CCPA, as applicable to the
                            Processing of Personal Data hereunder and in effect at the time of
                            Common Ninja&rsquo;s performance hereunder.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Data Subject</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means the identified or identifiable person to whom the
                            Personal Data relates.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>FADP</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo; means the </span>
                        <span style={{ fontWeight: 400 }}>Swiss </span>
                        <span style={{ fontWeight: 400 }}>
                            Federal Act on Data Protection of 19 June 1992, and as revised as
                            of 25 September 2020, the &ldquo;
                        </span>
                        <strong>Revised FADP</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>GDPR</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means the Regulation (EU) 2016/679 of the European
                            Parliament and of the Council of 27 April 2016 on the protection
                            of natural persons with regard to the processing of personal data
                            and on the free movement of such data, and repealing Directive
                            95/46/EC (General Data Protection Regulation).
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Personal Data</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo; or &ldquo;</span>
                        <strong>Personal Information</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means any information that identifies, relates to,
                            describes, is capable of being associated with, or could
                            reasonably be linked, directly or indirectly, to or with an
                            identified or identifiable natural person or Consumer, to the
                            extent such information
                        </span>
                        <span style={{ fontWeight: 400 }}> is processed by </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja</span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            solely on behalf of Customer, under this DPA and the Agreement
                            between Customer and{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja</span>
                        <span style={{ fontWeight: 400 }}>.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Services</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means the services provided to Customer by{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>
                            Common Ninja (including, without limitation) the Common Ninja
                            API(s) and the Common Ninja Plugins)
                        </span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            in accordance with the Agreement (including, without limitation).
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Sensitive Data</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means Personal Data that is protected under a special
                            legislation and requires unique treatment, such as &ldquo;special
                            categories of data&rdquo;, &ldquo;sensitive data&rdquo; or other
                            materially similar terms under applicable Data Protection Laws,
                            which may include any of the following: (a) social security
                            number, tax file number, passport number, {`driver's`} license number,
                            or similar identifier (or any portion thereof); (b) credit or
                            debit card number; (c) financial, credit, genetic, biometric or
                            health information; (d) information revealing racial or ethnic
                            origin, political opinions, religious or philosophical beliefs, or
                            trade union membership, genetic data or biometric data for the
                            purpose of uniquely identifying a natural person, data concerning
                            health or a person&rsquo;s sex life or sexual orientation, or data
                            relating to criminal convictions and offences; and/or (e) account
                            passwords in unhashed form.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Standard Contractual Clauses</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means the Standard Contractual Clauses between controllers
                            and processors, and between processors and processors, as approved
                            by the European Commission Implementing Decision (EU) 2021/914 of
                            4 June 2021, including all Annexes thereto, that are currently
                            located at{' '}
                            <Link href="/privacy/scc-c2p">
                                https://www.bracketsninja.com/privacy/scc-c2p
                            </Link>{' '}
                            and{' '}
                            <Link href="/privacy/scc-p2p">
                                https://www.bracketsninja.com/privacy/scc-p2p
                            </Link>
                            , respectively.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&ldquo;</span>
                        <strong>Sub-processor</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo; means any third party that Processes Personal Data under
                            the instruction or supervision of{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja</span>
                        <span style={{ fontWeight: 400 }}>.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>&quot;</span>
                        <strong>UK GDPR</strong>
                        <span style={{ fontWeight: 400 }}>
                            &quot; means the Data Protection Act 2018, as well as the GDPR as it
                            forms part of the law of England and Wales, Scotland and Northern
                            Ireland by virtue of section 3 of the European Union (Withdrawal)
                            Act 2018 and as amended by the Data Protection, Privacy and
                            Electronic Communications (Amendments etc.) (EU Exit) Regulations
                            2019 (SI 2019/419).
                        </span>
                    </li>
                </ol>
                <h4>2. PROCESSING OF PERSONAL DATA</h4>
                <ol>
                    <ol>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Roles of the Parties</strong>
                            <span style={{ fontWeight: 400 }}>
                                . The Parties acknowledge and agree that with regard to the
                                Processing of Personal Da
                            </span>
                            <span style={{ fontWeight: 400 }}>
                                ta solely on behalf of Customer, (i) Customer is the Controller
                                of Personal Data, (ii){' '}
                            </span>
                            <span style={{ fontWeight: 400 }}>Common Ninja</span>
                            <span style={{ fontWeight: 400 }}>
                                {' '}
                                is the Processor of such Personal Data.&nbsp;
                            </span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Customer&rsquo;s Processing of Personal Data</strong>
                            <span style={{ fontWeight: 400 }}>
                                . Customer, in its use of the Services, and Customer&rsquo;s
                                instructions to the Common Ninja, shall comply with Data
                                Protection Laws. Customer shall establish and have any and all
                                required legal bases in order to collect, Process and transfer
                                to Common Ninja the Personal Data, and to authorize the
                                Processing by Common Ninja, and for Common Ninja&rsquo;s
                                Processing activities on Customer&rsquo;s behalf, including the
                                pursuit of &lsquo;business purposes&rsquo; as defined under the
                                CCPA.&nbsp;
                            </span>
                        </li>
                        <li style={{ fontWeight: 400 }}>
                            <strong>Common Ninja&rsquo;s Processing of Personal Data</strong>
                            <span style={{ fontWeight: 400 }}>
                                . When Processing on Customer&rsquo;s behalf under the
                                Agreement, Common Ninja shall Process Personal Data for the
                                following purposes: (i) Processing in accordance with the
                                Agreement and this DPA; (ii) Processing for Customer as part of
                                its provision of the Services; (iii) Processing to comply with
                                Customer&rsquo;s reasonable and documented instructions; (iv)
                                rendering Personal Data fully anonymous, non-identifiable and
                                non-personal in accordance with applicable standards recognized
                                by Data Protection Laws and guidance issued thereunder; (v)
                                Processing as required under the applicable laws, and/or as
                                required by a court of competent jurisdiction or other competent
                                governmental or semi-governmental authority, provided that
                                Common Ninja shall inform Customer of the legal requirement
                                before Processing, unless such law or order prohibit such
                                information on important grounds of public interest.&nbsp;
                            </span>
                        </li>
                    </ol>
                </ol>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja shall inform Customer without undue delay if, in Common
                        Ninja&rsquo;s opinion, an instruction for the Processing of Personal
                        Data given by Customer infringes applicable Data Protection Laws. To
                        the extent that Common Ninja cannot comply with an instruction from
                        Customer, Common Ninja shall inform Customer, providing relevant
                        details of the issue, and, without liability to Customer,
                        temporarily cease all Processing of the affected Personal Data
                        (other than securely storing such data) and/or suspend
                        Customer&rsquo;s access to the Services.
                    </span>
                </p>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Details of the Processing</strong>
                        <span style={{ fontWeight: 400 }}>
                            . The subject-matter of Processing of Personal Data by Common
                            Ninja is the performance of the{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Services</span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            pursuant to the Agreement. The duration of the Processing, the
                            nature and purpose of the Processing, the types of Personal Data
                            and categories of Data Subjects Processed under this DPA are
                            further specified in{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Schedule 1</span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            (Details of Processing) to this DPA.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Sensitive Data</strong>
                        <span style={{ fontWeight: 400 }}>
                            . The Parties agree that the Services are not intended for the
                            processing of Sensitive Data, and that if Customer wishes to use
                            the Services to process Sensitive Data, it must first obtain the
                            Common Ninja&rsquo;s explicit prior written consent and enter into
                            any additional agreements as required by{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja</span>
                        <span style={{ fontWeight: 400 }}>.</span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>
                            CCPA Standard of Care; No Sale of Personal Information
                        </strong>
                        <span style={{ fontWeight: 400 }}>
                            . Common Ninja acknowledges and confirms that it does not receive
                            or process any Personal Information as consideration for any
                            services or other items that Common Ninja provides to Customer
                            under the Agreement. Common Ninja shall not have, derive, or
                            exercise any rights or benefits regarding Personal Information
                            Processed on Customer&rsquo;s behalf, and may use and disclose
                            Personal Information solely for the purposes for which such
                            Personal Information was provided to it, as stipulated in the
                            Agreement and this DPA. Common Ninja certifies that it understands
                            the rules, requirements and definitions of the CCPA and agrees to
                            refrain from selling (as such term is defined in the CCPA) any
                            Personal Information Processed hereunder without Customer&rsquo;s
                            prior written consent, nor taking any action that would cause any
                            transfer of Personal Information to or from Common Ninja under the
                            Agreement or this DPA to qualify as &ldquo;selling&rdquo; such
                            Personal Information under the CCPA.
                        </span>
                    </li>
                </ol>
                <h4>3. DATA SUBJECT REQUESTS</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja shall, to the extent legally permitted, notify Customer
                        or refer Data Subject or Consumer to Customer, if Common Ninja
                        receives a request from a Data Subject or Consumer to exercise their
                        rights (to the extent available to them under applicable Data
                        Protection Laws) of access, right to rectification, restriction of
                        Processing, erasure, data portability, objection to the Processing,
                        their right not to be subject to automated individual decision
                        making, to opt-out of the sale of Personal Information, or the right
                        not to be discriminated against (&ldquo;
                    </span>
                    <strong>Data Subject Request</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;). Taking into account the nature of the Processing, Common
                        Ninja shall assist Customer by implementing appropriate technical
                        and organizational measures, insofar as this is possible and
                        reasonable, for the fulfilment of Customer&rsquo;s obligation to
                        respond to a Data Subject Request under Data Protection Laws. Common
                        Ninja may advise Data Subjects on available features for
                        self-exercising their Data Subject Requests through the Services
                        (where appropriate), and/or refer Data Subject Requests received,
                        and the Data Subjects making them, directly to the Customer for its
                        treatment of such requests.
                    </span>
                </p>
                <h4>4. CONFIDENTIALITY</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja shall ensure that its personnel and advisors engaged in
                        the Processing of Personal Data have committed themselves to
                        confidentiality.
                    </span>
                </p>
                <h4>5. SUB-PROCESSORS&nbsp;</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Customer acknowledges and agrees that (a) Common Ninja&rsquo;s
                            Affiliates may be engaged as Sub-processors; and (b) Common Ninja
                            and Common Ninja&rsquo;s Affiliates on behalf of Common Ninja may
                            each engage third-party Sub-processors in connection with the
                            provision of the Services.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Common Ninja makes available to Customer the current list of
                            Sub-processors used by Common Ninja to process Personal Data via
                            <Link href="/privacy/sub-processors">
                                https://www.bracketsninja.com/privacy/sub-processors
                            </Link>
                            . Such Sub-processor list includes the identities of those
                            Sub-processors and the entity&rsquo;s country (&ldquo;
                        </span>
                        <strong>Sub-Processor</strong> <strong>List</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;). This Sub-Processor List is hereby deemed authorized upon
                            Customer&rsquo;s first use of the Services.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Common Ninja&rsquo;s webpage accessible via{' '}
                            <Link href="/privacy/sub-processors">
                                https://www.bracketsninja.com/privacy/sub-processors
                            </Link>{' '}
                            offers a mechanism to subscribe to notifications of new
                            Sub-processors used to Process Personal Data, to which Customer
                            shall subscribe, and when Customer subscribes, Common Ninja shall
                            provide notification of any new Sub-processor(s) before
                            authorizing such new Sub-processor(s) to Process Personal Data in
                            connection with the provision of the Services. If Customer wishes
                            to object to Common Ninja&rsquo;s use of a new Sub-processor, for
                            reasons relating to the protection of Personal Data intended to be
                            Processed by such Sub-processor, it may do so by notifying Common
                            Ninja promptly in writing within ten (10) days after receipt of a
                            Common Ninja notification in accordance with the mechanism set out
                            in this Section 5.3.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Common Ninja or its Affiliates on behalf of Common Ninja has
                            entered into a written agreement with each Sub-processor
                            containing appropriate safeguards to the protection of Personal
                            Data. Where Common Ninja engages a Sub-processor, the same or
                            materially similar data protection obligations as set out in this
                            DPA shall be imposed on such new Sub-processor by way of contract.
                            Where a Sub-processor fails to fulfil its data protection
                            obligations concerning its Processing of Personal Data, Common
                            Ninja shall remain responsible for the performance of the
                            Sub-processor&rsquo;s obligations.&nbsp;
                        </span>
                    </li>
                </ol>
                <h4>6. SECURITY &amp; AUDITS</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Controls for the Protection of Personal Data</strong>
                        <span style={{ fontWeight: 400 }}>. </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja </span>
                        <span style={{ fontWeight: 400 }}>
                            shall maintain industry-standard technical and organizational
                            measures for protection of Personal Data Processed
                            hereunder.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Audits and Inspections</strong>
                        <span style={{ fontWeight: 400 }}>
                            . Upon Customer&rsquo;s 14 days prior written request at
                            reasonable intervals (no more than once every 12 months),{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>Common Ninja shall provide</span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            information necessary to demonstrate compliance with this DPA, and
                            allow for and contribute to audits, including inspections,
                            conducted by Customer.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            In the event of an audit or inspections as set forth above,
                            Customer shall ensure that it (and each of its mandated auditors)
                            will not cause (or, if it cannot avoid, minimize) any damage,
                            injury or disruption to Common Ninja&rsquo;s premises, equipment,
                            personnel and business while conducting such audit or
                            inspection.&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            The audit rights set forth in{' '}
                        </span>
                        <span style={{ fontWeight: 400 }}>&lrm;</span>
                        <span style={{ fontWeight: 400 }}>6.2</span>
                        <span style={{ fontWeight: 400 }}>
                            {' '}
                            above, shall only apply to the extent that the Agreement does not
                            otherwise provide Customer with audit rights that meet the
                            relevant requirements of Data Protection Laws (including, where
                            applicable, article 28(3)(h) of the GDPR or the UK GDPR).
                        </span>
                    </li>
                </ol>
                <h4>7. DATA INCIDENT MANAGEMENT AND NOTIFICATION</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja maintains security incident management policies and
                        procedures and, to the extent required under applicable Data
                        Protection Laws, shall notify Customer without undue delay after
                        becoming aware of the accidental or unlawful destruction, loss,
                        alteration, unauthorized disclosure of, or access to Personal Data
                        Processed by Common Ninja on behalf of the Customer (a &ldquo;
                    </span>
                    <strong>Data Incident</strong>
                    <span style={{ fontWeight: 400 }}>
                        &rdquo;). Common Ninja shall make reasonable efforts to identify and
                        take those steps as Common Ninja deems necessary and reasonable in
                        order to remediate and/or mitigate the cause of such Data Incident
                        to the extent the remediation and/or mitigation is within Common
                        Ninja&rsquo;s reasonable control. The obligations herein shall not
                        apply to incidents that are caused by Customer or anyone who uses
                        the Services on Customer&rsquo;s behalf.
                    </span>
                </p>
                <h4>8. RETURN AND DELETION OF PERSONAL DATA</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Following termination of the Agreement and subject thereto, Common
                        Ninja shall, at the choice of Customer (indicated through the
                        Services or in written notification to Common Ninja by email to
                        privacy@commninja.com), delete or return to Customer all the
                        Personal Data it Processes solely on behalf of the Customer, and
                        shall delete existing copies of such Personal Data unless Data
                        Protection Laws require otherwise. To the extent authorized or
                        required by applicable law, Common Ninja
                    </span>{' '}
                    <span style={{ fontWeight: 400 }}>
                        may also retain one copy of the Personal Data solely for evidence
                        purposes and/or for the establishment, exercise or defense of legal
                        claims and/or for compliance with legal obligations.&nbsp;
                    </span>
                </p>
                <h4>9. CROSS-BORDER DATA TRANSFERS</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>
                            Transfers from the EEA, the United Kingdom and Switzerland to
                            countries that offer adequate level of data protection
                        </strong>
                        <span style={{ fontWeight: 400 }}>
                            . Personal Data may be transferred from EU Member States, the
                            three other EEA member countries (Norway, Liechtenstein and
                            Iceland) (collectively, &ldquo;
                        </span>
                        <strong>EEA</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;), the United Kingdom (&ldquo;
                        </span>
                        <strong>UK</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;) and Switzerland to countries that offer an adequate level
                            of data protection under or pursuant to the adequacy decisions
                            published by the relevant data protection authorities of the EEA,
                            the European Union, the Member States or the European Commission,
                            the UK, and/or Switzerland (&ldquo;
                        </span>
                        <strong>Adequacy Decisions</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;), as applicable, without any further safeguard being
                            necessary.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>
                            Transfers from the EEA, the United Kingdom and Switzerland to
                            other countries
                        </strong>
                        <span style={{ fontWeight: 400 }}>
                            . If the Processing of Personal Data by Common Ninja includes a
                            transfer (either directly or via onward transfer) from the EEA
                            (&ldquo;
                        </span>
                        <strong>EEA Transfer</strong>
                        <span style={{ fontWeight: 400 }}>&rdquo;), the UK (&ldquo;</span>
                        <strong>UK Transfer</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;), and/or Switzerland (&ldquo;
                        </span>
                        <strong>Swiss Transfer</strong>
                        <span style={{ fontWeight: 400 }}>
                            &rdquo;) to other countries which have not been subject to a
                            relevant Adequacy Decision, and such transfers are not performed
                            through an alternative recognized compliance mechanism as may be
                            adopted by Common Ninja for the lawful transfer of personal data
                            (as defined in the GDPR, the UK GDPR, the FADP, as relevant)
                            outside the EEA, the UK or Switzerland, as applicable, then (i)
                            the terms set forth in the Standard Contractual Clauses shall
                            apply to any such EEA Transfer; (ii) the terms set forth in
                            Standard Contractual Clauses, in accordance with Annex III thereto
                            (UK Cross Border Transfers) shall apply to any such UK Transfer;
                            (iii) the terms set forth in Standard Contractual Clauses, in
                            accordance with Annex IV thereto (Swiss Cross Border Transfers)
                            shall apply to any such Swiss Transfer; and (iv) the terms set
                            forth in Standard Contractual Clauses, in accordance with Annex V
                            thereto (Additional Safeguards) shall apply to any such transfers.
                        </span>
                    </li>
                </ol>
                <h4>10. OTHER PROVISIONS</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <strong>
                            Data Protection Impact Assessment and Prior Consultation
                        </strong>
                        <span style={{ fontWeight: 400 }}>
                            . Upon reasonable request from Customer, Common Ninja shall
                            provide with reasonable cooperation and assistance needed to
                            fulfil Customer&rsquo;s obligation under the GDPR or the UK GDPR
                            (as applicable) to carry out a data protection impact assessment
                            and shall provide reasonable assistance to Customer in the
                            cooperation or prior consultation with the Supervisory Authority.
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <strong>Modifications</strong>
                        <span style={{ fontWeight: 400 }}>
                            . Each Party may by at least forty-five (45) calendar {`days'`} prior
                            written notice to the other Party, request in writing any
                            variations to this DPA if they are required as a result of any
                            change in, or decision of a competent authority under, any Data
                            Protection Laws, to allow Processing of Customer Personal Data to
                            be made (or continue to be made) without breach of those Data
                            Protection Laws.
                        </span>
                    </li>
                </ol>

                <h3 className="center">Schedule 1 - Details of the Processing</h3>
                <h4>Nature and Purpose of Processing</h4>
                <ol>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Providing the Services to Customer;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Performing the Agreement, this DPA and/or other contracts executed
                            by the Parties;&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Acting upon Customer&rsquo;s instructions, where such instructions
                            are consistent with the terms of the Agreement;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Sharing Personal Data with third parties in accordance with
                            Customer&rsquo;s instructions and/or pursuant to Customer&rsquo;s
                            use of the Services (e.g., integrations between the Services and
                            any services provided by third parties, as configured by or on
                            behalf of Customer to facilitate the sharing of Personal Data
                            between the Services and such third party services);&nbsp;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            Complying with applicable laws and regulations;
                        </span>
                    </li>
                    <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                            All tasks related with any of the above.
                        </span>
                    </li>
                </ol>
                <h4>Duration of Processing</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Common Ninja will Process Personal Data pursuant to the DPA and
                        Agreement for the duration of the Agreement, unless otherwise agreed
                        upon in writing.&nbsp;
                    </span>
                </p>
                <h4>Type of Personal Data</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Personal Data contained in information received through the Common
                        Ninja API(s), which may include (without limitation) the following:
                        name, phone number, e-mail address, purchases, media files, images
                        and videos, and mailing address&nbsp;
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        OR (depending on the Customer&rsquo;s use of the Services)
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Personal Data contained in information received through the Common
                        Ninja Plugins used by the Customer.
                    </span>
                </p>
                <h4>Categories of Data Subjects</h4>
                <p>
                    <span style={{ fontWeight: 400 }}>
                        Customer&rsquo;s shoppers / end-users / website&rsquo;s visitors /
                        consumers (as appropriate).
                    </span>
                </p>
                <p>
                    <span style={{ fontWeight: 400 }}>Last Updated: August 2022</span>
                </p>
            </LongCopy>
        </Layout>
    );
};